import BaseService from './baseService';

class SearchService {   
    static search(keyword) {
        const url = `/Search/${keyword}`;
        return BaseService.getAndReturn(url, BaseService.returnAssignedArray, 'Unable to complete search', false);
    }
}
export default SearchService;